<script setup lang="ts">
import { computed } from 'vue';
import { timeSlots } from '../timeSlots';

/**
 * Lot AI [27] : choix d'une heure dans une liste de créneaux (au style des autres listes de l'appli), à la place
 * du champ « heure » du navigateur. `v-model` : « HH:MM ». Une heure posée ailleurs, entre deux créneaux, reste
 * proposée. Les autres attributs (`aria-label`, `id`, `data-testid`) vont sur la liste.
 */
const props = withDefaults(
  defineProps<{
    modelValue: string | null;
    /** Pas en minutes (15 par défaut, comme les rendez-vous ; 30 pour une liste plus courte). */
    step?: number;
    from?: string;
    to?: string;
    disabled?: boolean;
  }>(),
  { step: 15, from: '07:00', to: '20:00', disabled: false },
);
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

const options = computed(() =>
  timeSlots({ step: props.step, from: props.from, to: props.to, current: props.modelValue }),
);
const value = computed(() => props.modelValue?.slice(0, 5) ?? '');

function onChange(event: Event): void {
  const next = (event.target as HTMLSelectElement).value;
  if (next && next !== value.value) emit('update:modelValue', next);
}
</script>

<template>
  <select class="time-select" :value="value" :disabled="disabled" @change="onChange">
    <option v-if="!value" value="" disabled>Choisir une heure</option>
    <option v-for="o in options" :key="o.value" :value="o.value">{{ o.label }}</option>
  </select>
</template>
